import './main.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import renderViewsState from '../../shared/render-views-state';
import Animate from '../../shared/animation';

import Switch from '../components/switch';
import Calendar from '../../shared/calendar/main';
import Filters from '../../shared/filters/main';
import Currencies from '../../shared/currencies-filter';
import Table from './components/table/main';
import Search from  '../../shared/search/main';

import { selectors as rootSelectors } from '../../root';

const Main = renderViewsState(props => (
	<Animate>
		<div className="container__content payout-log-transfers">
			<div className="container__content-title">
				<div className="container__content-title-position border-hide">
					<h2 className="title">{props.intl('Payout log')}</h2>
				</div>
				<Switch intl={props.intl} />
			</div>

			<div className="container__content-body">
				<div className="payout-log-transfers__filter-position clearfix">
					<Filters {...props} {...props.filters} />
				</div>

				<div className="ui-control-bar">
					<div className="ui-control-bar__item modify-item---search">
						<div className="ui-control-bar__item-position">
							<Search
								{...props}
								placeholder="Search in comments"
								form="payoutLogTransfersSearchForm"
								action={props.search}
								initialValues={props.searchData} />
						</div>
					</div>
					<div className="ui-control-bar__item modify-item---calendar">
						<div className="ui-control-bar__item-position">
							<Calendar
								{...props.calendar}
								onInit={props.calendarInit}
								onToggle={props.calendarToggle}
								onChange={props.calendarChange}
								onApply={props.calendarApply}
								intl={props.intl}/>
						</div>
					</div>
					<div className="ui-control-bar__item modify-item---currency">
						<div className="ui-control-bar__item-position">
							<Currencies {...props}/>
						</div>
					</div>
					<div className="ui-control-bar__item">
						<div className="ui-control-bar__item-position">
							<button className="ui-btn ui-btn-primary apply" onClick={props.apply}>{props.intl('Apply')}</button>
							<button className="ui-btn ui-btn-secondary ui-icon-clear" onClick={props.clear} />
						</div>
					</div>
				</div>

				<div className="payout-log-transfers__table-position">
					<Table {...props} />
				</div>
			</div>
		</div>
	</Animate>
), 'view');

export default connect(
	state => ({
		data: selectors.getData(state),
		table: selectors.getTable(state),
		pagination: selectors.getPagination(state),
		intl: selectors.getIntl(state),
		progressBar: selectors.getProgressBar(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		can: selectors.getCan(state),
		calendar: selectors.getCalendar(state),
		filters: selectors.getFilters(state),
		currentCurrency: selectors.getCurrentCurrency(state),
		currentDateRange: selectors.getCurrentDateRange(state),
		listOfCurrencies: selectors.getListOfCurrencies(state),
		searchData: selectors.getSearchData(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payout-log/transfers/main.js